import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';
import moment from 'moment';

const Footer = () => {
  const [currentTime, setCurrentTime] = useState(moment().format('DD-MMM-YYYY h:mm A'));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format('DD-MMM-YYYY h:mm A'));
    }, 1000);

    return () => clearInterval(interval); 
  }, []);

  return (
    <footer className="footer">
      <Row className="justify-content-between fs--1 mt-2 mb-2 footer-credits">
        <Col sm="auto">
          <p className="mb-0">
            <span className="mb-0 footer-version">Version {version} </span>
            <a className="footer-link" href="https://mymediatalent.com" target="_blank" rel="noopener noreferrer">
              www.myvakildiary.com
            </a>
            <span className="footer-ars">
              Product of Satya Infosys {new Date().getFullYear()} &copy; All Rights Reserved
            </span>
            <a className="footer-satya-link" href="http://satyainfosys.com" target="_blank" rel="noopener noreferrer">
              www.satyainfosys.com
            </a>
            <span className="footer-time">{currentTime}</span>
          </p>
        </Col>
        <Col sm="auto"></Col>
      </Row>
    </footer>
  );
};

export default Footer;